"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IComponentFunctionSignalAssignmentSchema = exports.IActiveDriveModeSchema = void 0;
const zod_1 = require("zod");
const SignalId_1 = require("../DesignModels/SignalId");
const SignalDriveMode_1 = require("../DesignModels/SignalDriveMode");
exports.IActiveDriveModeSchema = zod_1.z.object({
    type: zod_1.z.nativeEnum({ ...SignalDriveMode_1.SignalOutputDriveType, ...SignalDriveMode_1.SignalInputDriveType }),
    pullupEnable: zod_1.z.boolean().optional(),
    pulldownEnable: zod_1.z.boolean().optional(),
});
exports.IComponentFunctionSignalAssignmentSchema = zod_1.z.object({
    componentSignalId: SignalId_1.SignalIdSchema,
    activeDriveModes: zod_1.z.array(exports.IActiveDriveModeSchema).optional(),
});
//# sourceMappingURL=IComponentFunctionSignalAssignment.js.map